export default "__VITE_ASSET__lDY3j3So__"